// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2333":"44aaef7aa530148c","3185":"87fc6519af24ff58"}[chunkId] + ".css";
};